import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, IconButton, Box, StepLabel, StepContent, Icon } from '@mui/material'
import { OptionSelectorComponent, ModelAutocompleteField } from '@front/squirtle/'


const Row1 = ({ schedule, formattedHours, ...props }) =>
  <Grid container spacing={1} alignItems='flex-end' size={12}>
    {!schedule &&
      <Grid size={1}>
        <IconButton onClick={() => window.open('/schedule/create', '_blank')} color='primary'>
          <Icon fontSize='inherit'>add_circle</Icon>
        </IconButton>
      </Grid>
    }
    <Grid size="grow">
      <ModelAutocompleteField
        name={'schedule'}
        label={I18n.t('schedule.label', { count: 2 })}
        model_name='schedule'
        labelKeys={['name']}
        searchMode='search'
        searchQuery={'startsWith'}
        autocompleteKey={'name'}
        config={{ forced_filter: { type: 'pricing' } }}
        selectFirst={false}
        loadOnMount
        required
      />
    </Grid>
    <Grid size={4}>
      <Typography>
        {formattedHours}
      </Typography>
    </Grid>
  </Grid >


const Row2 = ({ schedule, ...props }) =>
  <Grid container spacing={1} alignItems='flex-end' size={12}>
    <Grid size="grow">
      <OptionSelectorComponent
        value={_.get(schedule, 'applicable_days')}
        label={I18n.t('day.label', { count: 2 })}
        multiple={true}
        options={[
          { label: I18n.t('day.monday.default'), value: 'monday' },
          { label: I18n.t('day.tuesday.default'), value: 'tuesday' },
          { label: I18n.t('day.wednesday.default'), value: 'wednesday' },
          { label: I18n.t('day.thursday.default'), value: 'thursday' },
          { label: I18n.t('day.friday.default'), value: 'friday' },
          { label: I18n.t('day.saturday.default'), value: 'saturday' },
          { label: I18n.t('day.sunday.default'), value: 'sunday' }
        ]}
        disabled={true}
      />
    </Grid>
  </Grid >

const ScheduleSection = (props) => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('date.period')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 2, boxShadow: 6, borderRadius: 3 }}>
      <Grid container rowSpacing={2}>
        <Row1 {...props} />
        <Row2 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(ScheduleSection)
